import { cn } from '@dreamstack/util/src/cn'
import React from 'react'

// The vertical padding values are adjusted using FullWidthBackgroundContainer values
// Original values (designer specs): p-px-24 md:p-px-48 lg:p-px-160
// We instead conditionally apply adjusted spacing variants below.

interface ChildrenBlockSpacingContainerProps {
  withExtraVerticaLPadding?: boolean
  withExtraSideLPadding?: boolean
  className?: string
  children?: React.ReactNode
}

export const ChildrenBlockSpacingContainer: React.FC<
  ChildrenBlockSpacingContainerProps
> = ({
  withExtraVerticaLPadding,
  withExtraSideLPadding,
  className,
  children,
}) => {
  return (
    <div
      className={cn(
        // base spacing (space between blocks only)
        'space-y-px-32 ml:space-y-px-32 lg:space-y-px-32',
        // extra vertical padding
        withExtraVerticaLPadding &&
          'md:pt-[24px] md:pb-[48px] ml:pt-[112px] ml:pb-[160px]',
        // extra side padding
        withExtraSideLPadding && 'p-px-48 md:p-0',
        className
      )}
    >
      {children}
    </div>
  )
}
